import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Play, Pause } from 'lucide-react';
function InteractiveVideo({
  src
}: {
  src: string;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <div className="relative w-full h-full cursor-pointer group/video" onClick={togglePlay} data-id="element-59">
      <video ref={videoRef} src={`${src}#t=0.001`} preload="metadata" muted loop playsInline className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-60" />

      {/* Play/Pause Button Overlay */}
      <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover/video:bg-black/20 transition-colors duration-300" data-id="element-61">
        <div className={`w-14 h-14 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-charcoal shadow-lg transition-transform duration-300 ${isPlaying ? 'opacity-0 group-hover/video:opacity-100 scale-90' : 'opacity-100 scale-100'}`} data-id="element-62">
          {isPlaying ? <Pause size={24} className="fill-charcoal" data-id="element-63" /> : <Play size={24} className="fill-charcoal ml-1" data-id="element-64" />}
        </div>
      </div>
    </div>;
}
const mediaItems = [{
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/9yu9d6r1XZSRKzDAm8TNjF/ANTES Y DESPUÉS de labios con ácido hialuronico 💉 Los resultados sutiles que siempre destacamos.mp4',
  label: 'Armonización Labial'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/59KN4WcV51XhudLJfePq78/¿Queres_mejorar_caracteristicas_de_tu_nariz_sin_pasar_por_una_cirugia_👃🏻La_rinomodelacion_con_(1).jpg',
  label: 'Rinomodelación'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/r8GZ4DXxzy4ifFd9U8xvxe/MESOTERAPIA_FACIAL_🧴✨¿Cuales_son_sus_principales_beneficios_-_Mejora_la_textura_de_la_piel_-_Re.jpg',
  label: 'Mesoterapia Facial'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/1q8UJYP9fhwmFWi5gm5dTj/¿Queres_mejorar_caracteristicas_de_tu_nariz_sin_pasar_por_una_cirugia_👃🏻La_rinomodelacion_con_.jpg',
  label: 'Rinomodelación'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/gWy13pet1YsmJQnZcFpXkR/Tu momento de relax y de autocuidado 🤍Logra una renovación de tu piel ✨, eliminando impurezas e.mp4',
  label: 'Skin Quality'
}];
export function Gallery() {
  return <section className="py-24 bg-white border-t border-rosegold/10" data-id="element-65">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-66">
        <div className="text-center mb-16" data-id="element-67">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal mb-4" data-id="element-68">
            Experiencia Mantra
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-charcoal/70 text-lg max-w-2xl mx-auto" data-id="element-69">
            Resultados reales y momentos de cuidado. Un vistazo a la naturalidad
            y excelencia de nuestros procedimientos.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-70">
          {mediaItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative group rounded-2xl overflow-hidden aspect-[4/5] shadow-soft bg-ivory" data-id="element-71">
              {item.type === 'video' ? <InteractiveVideo src={item.src} data-id="element-72" /> : <img src={item.src} alt={item.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-73" />}

              {/* Overlay on Hover */}
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-charcoal/80 via-charcoal/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-74">
                <span className="text-white font-serif text-xl tracking-wide" data-id="element-75">
                  {item.label}
                </span>
              </div>
            </motion.div>)}

          {/* CTA Card to complete the 6-grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-rosegold/10 border border-rosegold/20 flex flex-col items-center justify-center text-center p-8 shadow-soft" data-id="element-76">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-rosegold mb-6 shadow-sm" data-id="element-77">
              <Sparkles size={28} strokeWidth={1.5} data-id="element-78" />
            </div>
            <h3 className="font-serif text-2xl text-charcoal mb-4" data-id="element-79">
              Tu turno de brillar
            </h3>
            <p className="text-charcoal/70 mb-8 text-sm md:text-base" data-id="element-80">
              Da el primer paso hacia tu mejor versión con una consulta
              personalizada.
            </p>
            <a href="#reservar" className="bg-rosegold text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-rosegold-600 transition-colors shadow-sm" data-id="element-81">
              Agendar cita
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}